import React, { useEffect, useState } from "react";
import axios from "axios";
import Login from "./Login";
import SubmitProject from "./components/submitProject";
import SubmitQuestion from "./components/submitQuestion";
 import SubmitRequest from "./components/submitRequest";
import SubmissionList from "./components/submissionList";
import QuestionList from "./components/questionList";
import mentors from "./components/Mentor";
import qna from "./components/qna";
import askmentor from "./components/askMentor";
import VoiceAssistant from "./components/VoiceAssistant";
import VoiceAssistantCyberLab from "./components/VoiceAssistantCyberLab";
import { ConversationProvider } from "@elevenlabs/react";

function App() {
const [user, setUser] = useState(null);
  const [projectInfo, setProjectInfo] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [view, setView] = useState("home"); //added
  const [refresh, setRefresh] = useState(false);
  const [studentName, setStudentName] = useState("");
  const [branch, setBranch] = useState("");
   const [college, setCollege] = useState("");
// normalize user role safely
const role = user?.role?.toLowerCase();

// role checks
const isAdmin = role === "admin";
const isPartner1 = role === "partner1";

const isStudentUMIT = role === "studentumit";
const isStudentSBJ = role === "studentsbj";
const isInternJ = role === "intern";
const isPartner2 = role === "partner2";
const isPartner3 = role === "partner3";

  const [editMode, setEditMode] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [studentRecord, setStudentRecord] = useState(null);

  const [showGroupInfo, setShowGroupInfo] = useState(false);
  const [showProjectInfo, setShowProjectInfo] = useState(false);
const btnStyle = {
    padding: "15px 20px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    minWidth: "250px"
  };
   const GROUP_LIMIT = 10;
  const allGroups = projects.flatMap((project) =>
  Object.keys(project.groups).map((group) => ({
    projectId: project.id,
    projectName: project.name,
    groupName: group,
    count: project.groups[group].length,
  }))
);
 // ==========================
  // LOAD LOGIN + DATA
  // ==========================
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    loadProjects();
    loadProjectInfo();
  }, []);

  const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://u2uprojects.coreaidataedge.com";
  /*
   useEffect(() => {
  if (API_URL) {
    loadProjects();
    loadProjectInfo();
  }
}, [API_URL]);
*/
useEffect(() => {
  console.log("USER:", user);
  console.log("ROLE:", user?.role);
}, [user]);
  const loadProjectInfo = async () => {
  try {
     const res = await axios.get(`${API_URL}/project-info`);
    setProjectInfo(res.data);
  } catch (error) {
    console.error("Error loading project info:", error);
  }
};

  const loadProjects = async () => {
    try {
       const res = await axios.get(`${API_URL}/projects`);
      setProjects(res.data);
    } catch (error) {
      console.error("Error loading projects:", error);
    }
  };

  // JOIN
  const joinGroup = async () => {
    if (!studentName.trim() || !branch || !college || !selectedProject || !selectedGroup) {
      alert("Please enter Name, Branch, Project and Group.");
      return;
    }

    const currentStudents = selectedProject.groups[selectedGroup] || [];

    const isDuplicate = currentStudents.some(
      (s) => s.name?.toLowerCase() === studentName.trim().toLowerCase()
    );

    if (isDuplicate) {
      alert("⚠️ Student already exists in this group!");
      return;
    }

    if (currentStudents.length >= GROUP_LIMIT) {
      alert(`⚠️ Group is full (${GROUP_LIMIT} members max)`);
      return;
    }

    try {
        await axios.post(`${API_URL}/join`, {
        projectId: selectedProject.id,
        groupName: selectedGroup,
        studentName: studentName.trim(),
        branch,
        college,
      });

      setStudentName("");
      setBranch("");
      setCollege("");
      await loadProjects();

      alert("✅ Successfully added to group");
    } catch (error) {
      console.error(error);
       alert(
    error.response?.data?.error || "Failed to join group"
  );
     // alert("Failed to join group");
    }
  };

  // FIND
  const findStudent = () => {
    let found = null;

    projects.forEach((project) => {
      Object.keys(project.groups).forEach((group) => {
        project.groups[group].forEach((student) => {
          if (
            student.name?.toLowerCase().trim() ===
            searchName.toLowerCase().trim()
          ) {
            found = {
              projectId: project.id,
              groupName: group,
              name: student.name,
              branch: student.branch,
              college: student.college || "",
            };
          }
        });
      });
    });

    if (!found) {
      alert("Student not found");
      return;
    }

    setStudentRecord(found);

    const project = projects.find((p) => p.id === found.projectId);
    setSelectedProject(project);
    setSelectedGroup(found.groupName);
    setStudentName(found.name);
    setBranch(found.branch);
    setCollege(found.college || "");

    alert("✅ Loaded for editing");
  };
const exportExcel = async () => {
  try {
    const res = await axios.get(
     `${API_URL}/export-excel`,
      {
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(
      new Blob([res.data])
    );

    const link = document.createElement("a");

    link.href = url;
    link.setAttribute(
      "download",
      "project-groups.xlsx"
    );

    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.error(err);
    alert("Export failed");
  }
};
  // UPDATE
  const updateStudent = async () => {
    try {
        await axios.post(`${API_URL}/update-student`, {
        oldName: studentRecord.name,
         oldGroupName: studentRecord.groupName,

        newProjectId: selectedProject.id,
        newGroupName: selectedGroup,
        newBranch: branch,
        newCollege:college,
      });

      alert("✅ Updated successfully");
      setStudentRecord(null);
      setSearchName("");
      loadProjects();
    } catch (error) {
      console.error(error);
      alert("Update failed");
    }
  };
const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };
// ==========================
  // LOGIN SCREEN
  // ==========================
  if (!user) {
    return <Login onLogin={setUser} />;
  }

if (view === "home") {
  return (
    
    <div style={{ padding: "30px", fontFamily: "Arial" }}>
 <ConversationProvider>
  <VoiceAssistant />

  {(isPartner1 || isAdmin) && (
    <VoiceAssistantCyberLab />
  )}
</ConversationProvider>
      <div style={{ textAlign: "right" }}>
        Welcome {user.username}

        <button
          onClick={logout}
          style={{
            marginLeft: 10,
            background: "red",
            color: "white"
          }}
        >
          Logout
        </button>
      </div>

      <h1>🎓 U2U TechXplore</h1>
      <p>Select an action below:</p>
      <div style={{ display: "flex", gap: "10px", marginTop: "30px" }}>
        {/* STUDENT INTERN ONLY */}
        {(isStudentUMIT || isAdmin) && (
        <button
          onClick={() => setView("selection")}
  
          style={{
      ...btnStyle,
      backgroundColor: "navy"
    }}
        >
          📌 Select Internship Project
        </button>
        )}
{(isStudentUMIT || isAdmin) && (
        <button
        onClick={() => window.open("https://u2uinterns.coreaidataedge.com", "_blank")}
  
        style={{
      ...btnStyle,
      backgroundColor: "purple"
    }}
>

        📊 View Intern Information
      </button>
      )}
    </div>
    <br></br>
<div
  style={{
    display: "flex",
    gap: "10px"
  }}
>
          {(isStudentUMIT || isAdmin) && (
  <button
    onClick={() => setView("submission")}
    style={{
      ...btnStyle,
      backgroundColor: "purple"
    }}
  >
    🧾 Submit Completed Project 
  </button>
          )}
          {(isStudentUMIT || isAdmin) && (
  <button
   onClick={() => setView("mentors")}
    style={{
      ...btnStyle,
      backgroundColor: "navy"
    }}
  >
    🧾 Meet The Mentors
  </button>
          )}
          {(isStudentUMIT || isAdmin) && (
  <button
   onClick={() => setView("qna")}
    style={{
      ...btnStyle,
      backgroundColor: "navy"
    }}
  >
    🧾 Q & A
  </button>
          )}
  </div>
  <br></br>
    <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}></div>
            {(isStudentUMIT || isAdmin) && (
   <button
   onClick={() => setView("askTeam")}
    //onClick={() => alert("Projects Submissions - Coming Soon!")}
    style={{
      ...btnStyle,
      backgroundColor: "green"
    }}
  >
    
    🧾 Submit Your Question to U2U Platform Team
  </button>
            )}
   <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}></div>
  <br></br>
            {(isStudentUMIT || isAdmin) && (
   <button
   onClick={() => setView("askmentor")}
    style={{
      ...btnStyle,
      backgroundColor: "green"
    }}
  >
    🧾 Submit Your Question to the Mentor
  </button>
            )}
     <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}></div>
   {(isPartner1 || isAdmin) && (
   <button
        onClick={() => window.open("https://cyberlabs.u2utechnology.com", "_blank")}
  
        style={{
      ...btnStyle,
      backgroundColor: "black"
    }}
>
        📊 Cybersecurity Labs
      </button>
   )}
       <button
        onClick={() => window.open("https://books.coreaidataedge.com", "_blank")}
  
        style={{
      ...btnStyle,
      backgroundColor: "purple"
    }}
>
        📊 Project References
      </button>
    </div>
  );
}
//Ask Team start
if (view === "askTeam") {
  return (
    
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <div style={{ textAlign: "right" }}>
  Welcome {user.username}

  <button
    onClick={() => setView("home")}
    style={{
      marginLeft: "10px",
      backgroundColor: "green",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Home
  </button>

  <button
    onClick={logout}
    style={{
      marginLeft: "10px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Logout
  </button>
</div>
      <h1>Submit Your Question</h1>

      <SubmitRequest onSubmit={() => setRefresh(!refresh)} />

      <hr />

    </div>
  );
}
//Ask Team End

//Ask mentors start
if (view === "askmentor") {
  return (
    
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <div style={{ textAlign: "right" }}>
  Welcome {user.username}

  <button
    onClick={() => setView("home")}
    style={{
      marginLeft: "10px",
      backgroundColor: "green",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Home
  </button>

  <button
    onClick={logout}
    style={{
      marginLeft: "10px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Logout
  </button>
</div>
      <h1>Submit Your Question</h1>

      <SubmitQuestion onSubmit={() => setRefresh(!refresh)} />

      <hr />
    </div>
  );
}

//Ask Mentor End
 if (view === "submission") {
  return (
    
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <div style={{ textAlign: "right" }}>
  Welcome {user.username}

  <button
    onClick={() => setView("home")}
    style={{
      marginLeft: "10px",
      backgroundColor: "green",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Home
  </button>

  <button
    onClick={logout}
    style={{
      marginLeft: "10px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Logout
  </button>
</div>
      <h1>Internship Project Submission Dashboard</h1>

      <SubmitProject onSubmit={() => setRefresh(!refresh)} />

      <hr />

      <SubmissionList refresh={refresh} />
    </div>
  );
}
//QNA
 if (view === "qna") {
  return (
    
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <div style={{ textAlign: "right" }}>
  Welcome {user.username}

  <button
    onClick={() => setView("home")}
    style={{
      marginLeft: "10px",
      backgroundColor: "green",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Home
  </button>

  <button
    onClick={logout}
    style={{
      marginLeft: "10px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Logout
  </button>
</div>
      <h1>Q&A</h1>
{qna.map((qna, index) => (
  <div key={index}>
    <h3>{qna.name}</h3>
    <p>{qna.question}</p>
    <p>{qna.answer}</p>
    <hr />
  </div>
))}

   
    </div>
  );
}
//===========QNA end
//
//========== Mentor
 if (view === "mentors") {
  return (
    
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <div style={{ textAlign: "right" }}>
  Welcome {user.username}

  <button
    onClick={() => setView("home")}
    style={{
      marginLeft: "10px",
      backgroundColor: "green",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Home
  </button>

  <button
    onClick={logout}
    style={{
      marginLeft: "10px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Logout
  </button>
</div>
      <h1>Meet The Mentors</h1>
{mentors.map((mentor, index) => (
  <div key={index}>
    <h3>{mentor.name}</h3>
    <p>{mentor.specialization}</p>
    <p>{mentor.Information}</p>
    <hr />
  </div>
))}

   
    </div>
  );
}
//===========Mentor end
if (view === "selection") {
  return (
      <div style={{ padding: "20px" }}>
<div style={{ textAlign: "right" }}>
  Welcome {user.username}

  <button
    onClick={() => setView("home")}
    style={{
      marginLeft: "10px",
      backgroundColor: "green",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Home
  </button>

  <button
    onClick={logout}
    style={{
      marginLeft: "10px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "6px 12px",
      borderRadius: "5px",
      cursor: "pointer"
    }}
  >
    Logout
  </button>
</div>
      
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>🎓 U2UInnovate Internship Project & Group Selection Portal</h2>
<h3>This Portal allows students to choose their internship Projects and Groups</h3>
<h4> 1. Step 1: View All Projects  and Select Your Project </h4>
<h4> 2. Step 2: View All Groups  and verify Group Information </h4>
<h4> 3. Step 3: Join Project Group </h4>
<h5> * Each Project has 5 groups, Each group can have 10 members </h5>
      {/* TOP SECTION */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Step 1: Select Internship Project</h3>

        <select
          onChange={(e) => {
            const proj = projects.find(
              (p) => p.id === Number(e.target.value)
            );
            setSelectedProject(proj);
            setSelectedGroup("");
          }}
        >
          <option>Select Project</option>
          {projects.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>

        <button
          style={{
            marginLeft: "10px",
            backgroundColor: "#007bff",
            color: "white",
            padding: "6px 12px",
            borderRadius: "5px",
          }}
          onClick={() => setShowProjectInfo(!showProjectInfo)}
        >
          {showProjectInfo ? "Hide Project Details" : "View Project Details"}
      
        </button>
        {/* Export Excel */}
      </div>
      {/* PROJECT DETAILS */}
{showProjectInfo && (
  <div style={{ marginBottom: "20px" }}>
    <h2>📘 Internship Projects Information</h2>

    {projectInfo.length === 0 ? (
      <p>No project information available</p>
    ) : (
      projectInfo.map((project) => (
        <div
          key={project.id}
          style={{
            border: "1px solid #ddd",
            padding: "15px",
            marginBottom: "15px",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <h3>{project.name}</h3>

          {project.description && (
            <p>
              <strong>Description:</strong> {project.description}
            </p>
          )}

          {project.technology && (
            <p>
              <strong>Technology:</strong> {project.technology}
            </p>
          )}

          {project.mentor && (
            <p>
              <strong>Mentor:</strong> {project.mentor}
            </p>
          )}

          {project.duration && (
            <p>
              <strong>Duration:</strong> {project.duration}
            </p>
          )}

          {project.objectives && (
            <>
              <strong>Objectives:</strong>
              <ul>
                {project.objectives.map((obj, i) => (
                  <li key={i}>{obj}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      ))
    )}
  </div>
)}
      {/* GROUP INFO BUTTONS */}
       <h3>Step 2: View Group Information</h3>
      <div style={{ marginBottom: "15px" }}>
        <button 
         style={{
            marginLeft: "10px",
            backgroundColor: "#007bff",
            color: "white",
            padding: "6px 12px",
            borderRadius: "5px",
          }}
        onClick={() => setShowGroupInfo(!showGroupInfo)}>
          {showGroupInfo ? "Hide Group Information" : "View Group Information"}
        </button>
         <button
    onClick={exportExcel}
    style={{
      backgroundColor: "purple",
      color: "white",
      border: "none",
      padding: "8px 12px",
      borderRadius: "5px",
      cursor: "pointer",
    }}
  >
    📥 Export Excel
  </button>
      </div>

      {/* GROUP INFO */}
      {showGroupInfo && (
        <div>
          <h2>📊 Group Information</h2>

          {projects.map((project) => (
            <div key={project.id}>
              <h3>{project.name}</h3>

              {Object.keys(project.groups).map((group) => (
                <div key={group}>
                  <strong>{group}</strong>

                  <ul>
                    {project.groups[group].map((student, i) => (
                      <li key={i}>
                        {student.name} — {student.branch} - { student.college}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* GROUP SELECT */}
      <>
  <h3>Step 3 : Select Group (All Projects)</h3>

  <select
    onChange={(e) => {
      const value = JSON.parse(e.target.value);

      setSelectedGroup(value.groupName);
      setSelectedProject(
        projects.find((p) => p.id === value.projectId)
      );
    }}
  >
    <option value="">Select Group</option>

    {allGroups.map((g, i) => (
      <option
        key={i}
        value={JSON.stringify({
          projectId: g.projectId,
          groupName: g.groupName,
        })}
      >
        {g.projectName} → {g.groupName} ({g.count})
      </option>
    ))}
  </select>
</>
{/* EDIT MODE SEARCH */}
      {editMode && (
        <div style={{ marginTop: "10px" }}>
          <input
            placeholder="Search student"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
          <button onClick={findStudent}>Search</button>
        </div>
      )}
      {/* INPUT SECTION */}
      {selectedGroup && (
        <div style={{ marginTop: "20px" }}>
          <input
            placeholder="Student Name"
            value={studentName}
            onChange={(e) => setStudentName(e.target.value)}
          />

          <select value={branch} onChange={(e) => setBranch(e.target.value)}>
            <option value="">Select Branch</option>
            <option>Information Technology</option>
            <option>Artificial Intelligence</option>
            <option>Data Science</option>
            <option>Computer Engineering</option>
            <option>Computer Science & Engineering</option>
            <option>Computer Science & Technology</option>
            <option>Electronics & Communications</option>
             <option>Computer Applications</option>
             <option>AI&DS</option>
             <option>Electronic Engineering VLSI D&T</option>
             <option>Electronics & ACT </option>
             <option>Robotics and AI</option>
              <option>VlSI - Design & Technology</option>
              <option>Plastic Technology</option>
             <option>Other</option>
          </select>
 <select value={college} onChange={(e) => setCollege(e.target.value)}>
            <option value="">Select College</option>
            <option>SBJITMR, Nagpur</option>
            <option>UMIT, Mumbai</option>
            <option>YCCE, Nagpur</option>
            <option>D-BATU, Lonere</option>
            <option>VTU, Belgaum</option>
            <option>PVGCOE Nashik</option>
            <option>MGM, University</option>
            <option>CSMSS,Sambhajinagar </option>
            <option>RCPIT, Shirpur</option>
            <option>TCSE, Mumbai</option>
            <option>AVCOE, Ghulewadi</option>
             <option>SYCET, Sambhajinagar</option>
             <option>CIPET, Chennai</option>
             <option>VVPCE, Ahmednagar</option>
            <option>Bhavna Trust College, Mumbai</option>
            <option>Other</option>
          </select>
          {/* ADD BUTTON */}
          <button onClick={joinGroup} 
          style={{ marginLeft: 10,
          backgroundColor: "green",
              color: "white",
              padding: "6px 12px",
              borderRadius: "5px",
          }}>
            ➕ Join Group
          </button>

          {/* EDIT MODE BUTTON MOVED HERE */}
          <button
            onClick={() => setEditMode(!editMode)}
            style={{
              marginLeft: 10,
              backgroundColor: "orange",
              color: "white",
              padding: "6px 12px",
              borderRadius: "5px",
            }}
          >
            ✏️ Edit Mode
          </button>

          {/* UPDATE BUTTON */}
          <button
            onClick={updateStudent}
            disabled={!studentRecord}
            style={{
              marginLeft: 10,
              backgroundColor: studentRecord ? "green" : "gray",
              color: "white",
            }}
          >
            Update
          </button>
        </div>
      )}
    </div>
    </div>
  );
}
}

export default App;